import { currencyData, imgSuffix } from './json'
import { Message } from 'element-ui'
export const requiredRule = (name= '该项') => 
  ({ required: true, message: `${name}不能为空`  });
export const isImage = (url) => {
  if(!url)
    return false;
  let s = url.lastIndexOf('.');
  let e = url.lastIndexOf('?');
  e = -1 ? url.length: e;
  let suffix = url.substring(s, e)
  return imgSuffix.indexOf(suffix.toLowerCase()) != -1
}
export const jsonParse = (data) => {
  try{
    return JSON.parse(data)
  }catch(e){
    return ''
  }
}
export const copyObj = (data) => 
  data
  ? JSON.parse(JSON.stringify(data))
  : undefined
export const toFile = data => {
  return data
  ? typeof data == 'string'
    ? {
        name: data,
        url: data
      }
    : data
  : {
    url: ''
  }
}
export const objEval = (obj, str) => {
  if(!str)
    return null
  if(str.indexOf('.') == -1)
    return obj[str]
  let splits = str.split('.');
  let result
  for(let i = 0; i < splits.length; i++){
    let key = splits[i]
    let temp = result
      ? result[key]
      : obj[key]
    if(!temp || typeof temp != 'object')
      return temp
    result = temp;
  }
  return result
}
const isNull = data => data === null || data === undefined || data === ''
export const formatLabel = (option, param, symbol = ' - ') => {
  if(!option)
    return undefined
  let arr = param.split(',');
  return arr.map(item => {
    let [ v1, v2 ] = item.split('|');
    let obj1 = objEval(option, v1);
    let obj2 = objEval(option, v2);
    if(!isNull(obj1))
      return obj1
    if(!isNull(obj2))
      return obj2
    return null;
  }).filter(
    item => item != null
  ).join(symbol)
}
export const copyText = data => {
  if(!data)
    return
  let oInput = document.createElement("input");
  oInput.value = data;
  oInput.readOnly = true;
  document.body.appendChild(oInput);
  oInput.select();
  oInput.setSelectionRange(0, data.length);
  document.execCommand("Copy");
  oInput.className = "oInput";
  oInput.style.display = "none";
  Message.success('复制成功')
}
export const downloadFile = (data, filename) => {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  // 创建新的URL并指向File对象或者Blob对象的地址
  const blobURL = window.URL.createObjectURL(blob)
  // 创建a标签，用于跳转至下载链接
  const tempLink = document.createElement('a')
  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', decodeURI(filename))
  // 兼容：某些浏览器不支持HTML5的download属性
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }
  // 挂载a标签
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  // 释放blob URL地址
  window.URL.revokeObjectURL(blobURL)
}
const fileKeys = ['file_code', 'file_part_content', 'name', 'url'];
export const fileToCode = data => {
  if(Array.isArray(data)){
    return data.map(item => fileToCode(item))
  }else if(typeof data === 'object' && 
    data instanceof Object){
    let keys = Object.keys(data);
    if(keys.length === 4 && 
      keys.every(item => fileKeys.indexOf(item) != -1)){
      return data.file_code;
    }else{
      let result = {};
      keys.forEach(key => {
        result[key] = fileToCode(data[key])
      })
      return result;
    }
  }
  return data;
}
export const useDebounceFn = (fn, wait) => {
  let timer
  return function(){
    if(timer){
      clearTimeout(timer)
      timer = undefined
    }
    timer = setTimeout(
      () => fn.apply(this, arguments), 
      wait
    )
  }
}
export const toFloat = data => {
  const type = typeof data
  if(type == 'number')
    return data
  if(type == 'string'){
    let result = parseFloat(data)
    return isNaN(result)
      ? 0
      : result
  }
  return 0
}
export const randomStr = () =>
  Math.random().toString(32).substr(2, 15)
export const getCurrencyName = code => {
  if(!code)
    return '未知货币'
  let result = currencyData.find(
    item => item.currency == code
  )
  return result &&
    result.name ||
    '未知货币'
}
export const closeWindow = () => {
  var userAgent = navigator.userAgent;
  if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
    window.location.href = "about:blank";
    window.close();
  } else {
    window.opener = null;
    window.open("", "_self");
    window.close();
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js